import { Box, Flex, Skeleton, SkeletonCircle } from '@chakra-ui/react';

export function TicketListSkeleton() {
  return (
    <Flex p={4} gap={3} align="center">
      <SkeletonCircle size="8" flexShrink={0} />

      <Box flex={1} minW={0}>
        <Flex justify="space-between" align="center" mb={2}>
          <Skeleton height="12px" width="100px" />
          <Skeleton height="10px" width="60px" />
        </Flex>

        <Flex justify="space-between" align="center">
          <Skeleton height="10px" width="140px" />
          <Skeleton height="12px" width="80px" borderRadius="full" />
        </Flex>
      </Box>
    </Flex>
  );
}
